<dsd-container
  border-radius="sm"
  padding="none"
  margin="none"
  [backgroundColor]="backgroundColor"
  [backgroundColorCustom]="backgroundColorCustom"
>
  <h3 [ngClass]="textColor" class="label dsd-d-block dsd-fw-bold dsd-mb-0 dsd-b-40" data-cy="title">Total</h3>
  <span [ngClass]="[size, textColor, amountSize]" class="amount dsd-d-block dsd-ta-center" data-cy="content"
    >{{ amount | desjardinsCurrency }}&nbsp;{{ frequencyLabel | translate }}</span
  >
</dsd-container>
